import { Accordion } from "@mantine/core";
import type { InstallmentConfiguration } from "../../../../../DeliveryOverview.types";
import { InstallmentForm } from "./InstallmentForm/InstallmentForm";

interface InstallmentElementProps {
  contractId: string;
  isOpen: boolean;
  installment: InstallmentConfiguration;
  estimatedConsumptionBlocked?: boolean;
  historyInstallmentsBlocked?: boolean;
  advancePaymentsPlanAlreadyExists: boolean;
  onChange: (installment: InstallmentConfiguration) => void;
}

function InstallmentElement({
  contractId,
  isOpen,
  installment,
  onChange,
  estimatedConsumptionBlocked,
  historyInstallmentsBlocked,
  advancePaymentsPlanAlreadyExists
}: InstallmentElementProps) {
  return (
    <Accordion.Item
      className="InstallmentElement"
      key={installment.year}
      value={installment.year.toString()}
    >
      <Accordion.Control>Jahr {installment.year}</Accordion.Control>
      <Accordion.Panel>
        <InstallmentForm
          advancePaymentsPlanAlreadyExists={advancePaymentsPlanAlreadyExists}
          contractId={contractId}
          estimatedConsumptionBlocked={estimatedConsumptionBlocked}
          historyInstallmentsBlocked={historyInstallmentsBlocked}
          installment={installment}
          isOpen={isOpen}
          onChange={onChange}
        />
      </Accordion.Panel>
    </Accordion.Item>
  );
}

export { InstallmentElement };
